var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',[_c('el-aside',{attrs:{"width":"auto"}},[_c('main-aside')],1),_c('el-container',[_c('el-header',[_c('main-header')],1),_c('el-main',{staticStyle:{"height":"0","flex-grow":"1"}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }